import { Box, CircularProgress, Typography, useTheme } from '@mui/material';
import { progressComponentStyles } from './ProgressComponent.styles';

interface ProgressComponentProps {
  text?: string;
}

export const ProgressComponent = ({ text = 'Loading' }: ProgressComponentProps) => {
  const theme = useTheme();

  return (
    <Box sx={progressComponentStyles.container(theme)}>
      <CircularProgress color="primary" sx={progressComponentStyles.progress()} />
      <Typography variant="body1" sx={progressComponentStyles.text(theme)}>
        {text}
      </Typography>
    </Box>
  );
};

export default ProgressComponent;
